import React from 'react';
import { Card } from '../ui/Card';
import { Link } from 'react-router-dom';
import { ProtocolTimer } from '../Dashboard/ProtocolTimer';

export function DashboardTab() {
  const protocols = [
    { id: '16:8', label: 'Daily Metabolic', duration: '16h fast · 8h eat' },
    { id: '18:6', label: 'Accelerated Fat Burn', duration: '18h fast · 6h eat' },
    { id: 'OMAD', label: 'One Meal A Day', duration: '23h fast · 1h eat' },
    { id: 'TMAW', label: 'Two Meals A Week', duration: '48-72h fast · Weekly' },
    { id: 'OMAW', label: 'One Meal A Week', duration: '5-7 days · Weekly' },
    { id: 'IRF', label: 'Insulin Reset Fast', duration: 'Biochemical mission' },
  ];

  return (
    <div className="space-y-6 p-4">
      {/* Protocol Timer */}
      <ProtocolTimer />

      {/* Protocol Selector */}
      <Card className="bg-surface-container border border-outline">
        <div className="grid grid-cols-3 gap-2 px-4 py-4">
          {protocols.map((protocol) => (
            <Link
              key={protocol.id}
              to={`/protocol/${protocol.id}`}
              className={`
                flex flex-col items-center justify-center gap-1.5 rounded-xl border border-outline p-3 transition-all
                hover:bg-surface-container-high
              `}
            >
              <span className="text-sm font-bold text-primary">{protocol.id}</span>
              <span className="text-xs text-on-surface-variant">{protocol.label}</span>
            </Link>
          ))}
        </div>
      </Card>
    </div>
  );
}
